<template>
  <div class="ccgd-header">
    <div class="ccgd-title">
      <div class="ccgd-title-icon">
        <i class="fa-duotone fa-layer-group ccgd-ico ccgd-ico--header"></i>
      </div>

      <div class="ccgd-title-text">
        <div class="ccgd-title-main">{{ title }}</div>
        <div class="ccgd-title-sub">{{ results }} results</div>
      </div>
    </div>

    <div class="ccgd-header-actions">
      <div class="ccgd-view-toggle">
        <kbutton
          class="ccgd-toggle-btn"
          :class="{ active: viewMode === 'list' }"
          @click="setView('list')"
          title="List"
        >
          <i class="fa-duotone fa-rectangle-list ccgd-ico ccgd-ico--header"></i>
        </kbutton>
        <kbutton
          class="ccgd-toggle-btn"
          :class="{ active: viewMode === 'grid' }"
          @click="setView('grid')"
          title="Grid"
        >
          <i class="fa-duotone fa-grid ccgd-ico ccgd-ico--header"></i>
        </kbutton>
      </div>

      <kbutton
        v-if="sendNotiButton"
        class="ccgd-btn ccgd-btn-solid"
        :disabled="sending"
        :aria-busy="sending ? 'true' : 'false'"
        @click="$emit('send-task-notification')"
      >
        <i v-if="sending" class="fa-solid fa-spinner-third fa-spin ccgd-ico ccgd-ico--header"></i>
        <i v-else class="fa-duotone fa-envelope ccgd-ico ccgd-ico--header"></i>
        {{ sending ? "Sending..." : "Send Notifications" }}
      </kbutton>

      <kbutton
        class="ccgd-btn ccgd-btn-ghost"
        @click="$emit('close')"
        title="Close"
      >
        <i class="fa-duotone fa-xmark ccgd-ico ccgd-ico--header"></i>
      </kbutton>
    </div>
  </div>
</template>

<script>
import { Button } from "@progress/kendo-vue-buttons"

const STORAGE_KEY = "cc_griddialog_view_mode"

export default {
  name: "GridDialogHeader",
  components: { kbutton: Button },
  props: {
    title:          { type: String,  default: "" },
    results:        { type: Number,  default: 0  },
    viewMode:       { type: String,  default: "list" },
    sendNotiButton: { type: Boolean, default: false },
    // Work Item #9107: blocks a second click while notifications are being sent.
    sending:        { type: Boolean, default: false }
  },
  emits: ["set-view", "send-task-notification", "close"],
  mounted() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      if (saved === "grid" || saved === "list") {
        this.$emit("set-view", saved)
      }
    } catch {}
  },
  methods: {
    setView(mode) {
      try {
        localStorage.setItem(STORAGE_KEY, mode)
      } catch {}
      this.$emit("set-view", mode)
    }
  }
}
</script>

<style src="@/assets/css/commandcenter/commandcenter.css"></style>

<style scoped>
.ccgd-ico--header {
  --fa-primary-color: var(--notification-blue);
  --fa-secondary-color: rgba(37, 99, 235, 0.28);
  --fa-secondary-opacity: 1;
}

.ccgd-btn-ghost .ccgd-ico--header {
  --fa-primary-color: rgba(15, 23, 42, 1);
  --fa-secondary-color: rgba(37, 99, 235, 1);
  --fa-secondary-opacity: 1;
}

.ccgd-btn-solid .ccgd-ico--header {
  --fa-primary-color: #fff;
  --fa-secondary-color: rgba(255, 255, 255, 0.55);
  --fa-secondary-opacity: 1;
}
</style>